import { Role } from '@caresend/types';
import update from 'immutability-helper';
import { encryptData } from '../environment/data/privateHelpers.js';
import { arrayToObj } from '../languageExtensions/array.js';
import 'lodash-unified';

const encryptResults = async results => {
  const resultsArray = Object.values(results);
  const promises = resultsArray.map(async result => {
    const resultWithoutEncrypted = update(result, {
      $unset: ['result']
    });
    const encryptedResult = Object.assign(Object.assign({}, resultWithoutEncrypted), result.result ? {
      result: await encryptData(result.result)
    } : undefined);
    return encryptedResult;
  });
  const encryptedResultsArray = await Promise.all(promises);
  return arrayToObj(encryptedResultsArray, 'productID');
};
const encryptProcedureCanceled = async procedureCanceled => {
  if (procedureCanceled.canceledByRole !== Role.PATIENT || !procedureCanceled.canceledBy) return procedureCanceled;
  return Object.assign(Object.assign({}, procedureCanceled), {
    canceledBy: await encryptData(procedureCanceled.canceledBy)
  });
};
async function encryptProcedure(procedure) {
  const {
    contact,
    results,
    procedureCanceled
  } = procedure;
  const procedureWithoutEncrypted = update(procedure, {
    $unset: ['contact', 'procedureCanceled', 'results']
  });
  const encryptedProcedure = procedureWithoutEncrypted;

  if (contact) {
    encryptedProcedure.contact = await encryptData(contact);
  }

  if (results) {
    encryptedProcedure.results = await encryptResults(results);
  }

  if (procedureCanceled) {
    encryptedProcedure.procedureCanceled = await encryptProcedureCanceled(procedureCanceled);
  }

  return encryptedProcedure;
}

export { encryptProcedure, encryptProcedureCanceled, encryptResults };
